import { useSelector } from 'react-redux';
import { selectHasReadMatchlistsPermission } from 'app/modules/session/selectors';
import { useQuery } from '@tanstack/react-query';
import { get } from 'app/shared/utils/fetchr';
import { MATCHLIST_QUERY_KEYS } from 'app/modules/matchlist/queries/keys';
import { Blacklist } from 'app/modules/lists/models';

export const useGetMatchlist = (id?: number) => {
  const hasReadMatchlistPermission = useSelector(
    selectHasReadMatchlistsPermission,
  );
  return useQuery({
    enabled: hasReadMatchlistPermission && Boolean(id),
    queryFn: () => get<Blacklist>(`/blacklists/${id}`),
    // query is only enabled if id exists
    queryKey: MATCHLIST_QUERY_KEYS.getMatchlist(id!),
  });
};
